'use strict';

/**
 * @description Wrapper for Axios request interceptor. Catches all outbound requests\
 * @param {object} error - The 4xx status response object
 */
function defaultErrorInterceptor (error) {
  if (!error.response) {
    return {
      ok: false,
      status: 499,
      errorMessage: 'Request cancelled',
      data: null
    };
  } else if (error.response.status === 401) {
    return {
      ok: false,
      status: error.response.status,
      errors: Object.freeze([].concat(error.response.data.exception || [])),
      errorMessage: 'Invalid Credentials',
      data: null
    };
  }
  return {
    ok: false,
    status: error.response.status,
    errors: Object.freeze([].concat(error.response.data.exception || [])),
    errorMessage: error.response.Message || 'An error occurred while processing the request',
    data: null
  };
}

export default defaultErrorInterceptor;
